export default (theme) => ({
    pageContent: {
      marginLeft: 220,
    },
    inputContainerStyle: {
      padding: "20px 30px 30px 30px",
    },
    contactsBarContainer: {
      padding: "8px 30px",
      backgroundColor: "#f3f3f3",
    },
    contactBarTitle: {
      fontSize: 13,
      fontWeight: 600,
    },
    contactsTableContainer: {
      padding: "18px",
    },
  });
  